// extracted by mini-css-extract-plugin
module.exports = {"navbar":"styles_navbar__sTuFB","white_btn":"styles_white_btn__t7Jhc"};